import React from "react";
import {
  FilterQuery,
  NumericParameterRange,
  ParameterFilterOption,
  ParameterRangeFilter,
} from "../../../../../../microservices/functions/src/types/product_catalog/catalog_api_types";
import { RangeSlider } from "../../components/range_slider";
import { useSliderRange } from "../../helpers/use_slider_range";
import { useToggleParameterFilter } from "../../helpers/use_toggle_parameter_filter";
import { makeRangeFilter } from "../helpers/parameter_filter_utils";
import { ParameterTitleButton } from "./parameter_title_button";
import { ParameterFilterChangeHandler } from "../types";

type Range = [number, number];

const formatValue = (value: string, unit: string | null) =>
  unit === null ? value : `${value} ${unit}`;

type NumericParameterFilterControlsProps = {
  parameter: ParameterFilterOption;
  range: NumericParameterRange[];
  filteredParameters: FilterQuery["parameters"];
  onChange: ParameterFilterChangeHandler;
  onShowHint: (description: string) => void;
};

export const NumericParameterFilterControls = ({
  parameter,
  range,
  onChange,
  filteredParameters,
  onShowHint,
}: NumericParameterFilterControlsProps): JSX.Element | null => {
  const [isExpanded, toggleIsExpanded] = useToggleParameterFilter(
    parameter,
    filteredParameters?.[parameter.id]
  );

  const appliedFilterValue = (filteredParameters?.[parameter.id] as
    | ParameterRangeFilter
    | undefined)?.range;

  const { values, sliderProps } = useSliderRange(
    range,
    appliedFilterValue === undefined
      ? undefined
      : [appliedFilterValue.gte, appliedFilterValue.lte],
    ([from, to]: Range) => {
      onChange(parameter.id, makeRangeFilter(from, to));
    }
  );

  return (
    <fieldset title={parameter.name}>
      <ParameterTitleButton
        parameter={parameter}
        isExpanded={isExpanded}
        toggleIsExpanded={toggleIsExpanded}
        onShowHint={onShowHint}
      />{" "}
      {isExpanded && (
        <div className="range-filter">
          <strong className="title">
            <span className="range">
              <span>Od</span>{" "}
              <em>{formatValue(values.from[1], parameter.unit)}</em>{" "}
              <span>do</span>{" "}
              <em>{formatValue(values.to[1], parameter.unit)}</em>
            </span>
          </strong>

          {sliderProps.max > 0 && <RangeSlider {...sliderProps} />}
        </div>
      )}
    </fieldset>
  );
};
